import { render, staticRenderFns } from "./featureFour.vue?vue&type=template&id=08313a42&"
import script from "./featureFour.vue?vue&type=script&lang=js&"
export * from "./featureFour.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports